import {initBodyScroll, killBodyScroll} from "./common/overlayScrollbars.js";
import { OverlayScrollbars } from 'overlayscrollbars';
import { slideToggle } from '@roghz/slidetoggle';
import Cookies from 'js-cookie';
import './animate.js'

document.addEventListener("DOMContentLoaded", function () {
    const appHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", appHeight);
    window.addEventListener("scroll", appHeight);
    appHeight();

    const siteHeader = document.querySelector('.site-header');
    const siteLogo = document.querySelector('.site-header__logo');
    const mobileNav = document.querySelector('.site-header__nav');
    const navWrapper = document.querySelector('.site-header__nav--scroll');
    const hamburger = document.getElementById('hamburger');
    const menuItems = document.querySelectorAll('.menu > .menu-item');

    let navScrollInstance = null;

    // Function to close all menu items
    const closeAllMenuItems = () => {
        menuItems.forEach(item => {
            const link = item.querySelector('.nav-link');
            const submenu = item.querySelector('.submenu');
            if (link?.classList.contains('active')) {
                link.classList.remove('active');
                if (submenu) {
                    submenu.style.display = 'none';
                }
            }
        });
    };

    // Handle mobile menu clicks
    menuItems.forEach(item => {
        const link = item.querySelector('.nav-link');
        const submenu = item.querySelector('.submenu');

        if (link && submenu) {
            link.addEventListener('click', (e) => {
                if (window.matchMedia('(max-width: 1279px)').matches && item.classList.contains('dropdown')) {
                    e.preventDefault();
                    link.classList.toggle('active');
                    slideToggle(submenu, 500, 'flex');

                    menuItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            const otherLink = otherItem.querySelector('.nav-link');
                            const otherSubmenu = otherItem.querySelector('.submenu');
                            if (otherLink?.classList.contains('active')) {
                                otherLink.classList.remove('active');
                                slideToggle(otherSubmenu, 500, 'flex');
                            }
                        }
                    });
                }
            });
        }
    });

    // Handle hamburger menu
    hamburger?.addEventListener('click', function(e) {
        if (hamburger.classList.contains('active')) {
            hamburger.classList.remove('active');
            siteLogo.classList.remove('active');
            siteHeader.classList.remove('active');
            mobileNav.classList.remove('active');
            initBodyScroll();
            closeAllMenuItems();

            if (navScrollInstance) {
                navScrollInstance.destroy();
                navScrollInstance = null;
            }
        } else {
            siteHeader.classList.remove('sticky', 'fixed');
            window.scrollTo({ top: 0, behavior: 'instant' });

            hamburger.classList.add('active');
            siteLogo.classList.add('active');
            siteHeader.classList.add('active');
            mobileNav.classList.add('active');
            killBodyScroll();

            if (navWrapper && !navScrollInstance) {
                navScrollInstance = OverlayScrollbars(navWrapper, {
                    scrollbars: {
                        autoHide: 'never',
                    },
                });
            }
        }
    });

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (window.matchMedia('(min-width: 1280px)').matches) {
                closeAllMenuItems();
            }
        }, 250);
    });

    // Header scroll behavior
    const header = document.querySelector('.site-header');
    const footerBar = document.querySelector('.footer-bar');
    const footerBarClose = document.querySelector('.footer-bar__close');
    const siteFooter = document.querySelector('.site-footer');

    if (footerBar && Cookies.get('fintua_footer_bar_closed')) {
        footerBar.classList.add('disabled');
    }

    if (footerBarClose) {
        footerBarClose.addEventListener('click', function() {
            Cookies.set('fintua_footer_bar_closed', 'true', { expires: 1 });

            if (footerBar) {
                footerBar.classList.add('disabled');
            }
        });
    }

    if (header) {
        const headerHeight = header.offsetHeight;
        let lastScrollTop = 0;

        const handleHeaderScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollingDown = scrollTop > lastScrollTop;

            // Check if footer is visible
            const isFooterVisible = () => {
                if (!siteFooter) return false;
                const footerRect = siteFooter.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                return footerRect.top <= windowHeight;
            };

            // Add fixed class after 2x header height
            if (scrollTop > headerHeight * 2) {
                header.classList.add('fixed');

                // Handle footer bar
                if (footerBar) {
                    if (scrollingDown && !isFooterVisible()) {
                        footerBar.classList.add('sticky');
                    } else {
                        footerBar.classList.remove('sticky');
                    }
                }
            } else {
                header.classList.remove('fixed');
                if (footerBar) {
                    footerBar.classList.remove('sticky');
                }
            }

            // Add sticky class when scrolling up and past 4x header height
            if (!scrollingDown && scrollTop > headerHeight * 4) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }

            lastScrollTop = scrollTop;
        };

        // Throttle scroll event
        let ticking = false;
        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    handleHeaderScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });
    }
});
